import { render } from "./ToolBrandCard.vue?vue&type=template&id=22cdb084&scoped=true&ts=true"
import script from "./toolBrandCardHelper.ts?vue&type=script&lang=ts"
export * from "./toolBrandCardHelper.ts?vue&type=script&lang=ts"

import "./ToolBrandCard.vue?vue&type=style&index=0&id=22cdb084&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cdb084"]])

export default __exports__